export const ReCAPTCHAKeysV3 = '6LeO59IjAAAAAGDC046Ef8Qb8rQO9jJ-25ppf_53';
export const footerLink = {
  help: '/',
  communication: 'https://www.edenred.com.tr/iletisim',
  protectionOfPersonalData: 'https://www.edenred.com.tr/kisisel-verilerin-korunmasi',
  cookiePolicy: 'https://www.edenred.com.tr/cerez-politikasi',
  facebook: '/',
  instagram: '/',
  linkedin: '/',
  youtube: '/',
  twitter: '/',
};

export const personalDataProtectionLaw = 'https://www.edenred.com.tr/kisisel-verilerin-korunmasi';

export const loginApplicationLink =
  'https://yemek-karti.ticket.com.tr/basvuru/?utm_source=ticketonline&utm_medium=banner&utm_campaign=ticket-online-login&utm_content=basvurmak-icin-tiklayin';
export const sessionModalMinutes = {
  modalMinutes: 2,
};

export const loginTimeStorageKey = 'login-time';
export const languageStorageKey = 'language';
export const profileAlertKey = 'profile-alert';

export const dateFormat = 'DD MMMM YYYY';
export const dateFormat2 = 'DD/MM/YYYY';
export const defaultDateFormat = 'DD.MM.YYYY';
export const dateTimeFormat = 'DD.MM.YYYY HH:mm';
